<template>
  <div class="frontconrtM" @click="transmit">
    <img class="qj" src="../assets/img/qj.png" alt=""/>
    <div class="stakeNo">
      <!-- <div class="first">{{ stakeNo.first }}</div>
      <div class="second">{{ stakeNo.second }}</div>
      <div class="third">{{ stakeNo.third }}</div>
      <div class="fourth">{{ stakeNo.fourth }}</div>
      <div class="fifth">{{ stakeNo.fifth }}</div>
      <div class="sixth">{{ stakeNo.sixth }}</div> -->

      <!-- <div class="first">{{ stakeNo.sixth }}</div> -->
      <div class="first">{{ }}</div>
      <div class="second">{{ stakeNo.fifth }}</div>
      <div class="third">{{ stakeNo.fourth }}</div>
      <div class="fourth">{{ stakeNo.third }}</div>
      <div class="fifth">{{ stakeNo.second }}</div>
      <div class="sixth">{{ stakeNo.first }}</div>

       <!-- <div class="first">K1+104</div>
      <div class="second">K1+103</div>
      <div class="third">K1+102</div>
      <div class="fourth">K1+101</div>
      <div class="fifth">K1+100</div>
      <div class="sixth">K1+99</div> -->
    </div>
    <div class="Mechanics">
      <div
        v-for="(item, index) in pavePlusList"
        :key="index+'p'"
        :item-id="item.id"
      >
        <div class="pavePlus" :class="pavePlusList.length<=1?'middle':index == 1 ? 'leftStyle' : 'rightStyle'">
          <div class="transportCar" :class="pavePlusList.length<=1?'oneS':'twoS'" @click="paveDetailShow(item)"></div>
          <div
            class="dischargePlate"
            :class="pavePlusList.length<=1?'middlePlate':''"
            v-if="dischargePlates[index]"
          >{{ dischargePlates[index] }}</div>
           <!-- <div
            class="dischargePlate"
            :class="pavePlusList.length<=1?'middlePlate':''"
          >苏A123456</div> -->
          <div
            class="paveMachine"
            :class="pavePlusList.length<=1?'middleT':''"
            v-if="pavingStatus != 2"
            @click="paveDetailShow(item)"
          ></div>
          <div class="wifi" :class="pavePlusList.length<=1?'noWifi':''" v-if="pavingStatus != 2"></div>
          <div class="cameraFront" :class="pavePlusList.length<=1?'middleV':'twoV'" v-if="index==0" @click="openFront"></div>
          <div :class="index == 1 ?'detail':'detailRight'" v-if="pavingStatus != 2 && paveNo == item.no">
            <div class="detailCon">
              <div>摊铺机</div>
            <div>编号:{{item.no}}</div>
            <div v-if="item.temp!=null">温度:{{item.temp}}°C</div>
            <div>速度:{{item.speed}}m/min</div>
            </div>
          </div>
        </div>
      </div>
      <!-- @click="steelDetailShow(item)" -->
      <div
        v-for="(item, index) in steelRollerList"
        :key="index+'s'"
        :item-id="item.id"
        @click="steelDetailShow(item)" 
      >
      <div v-if="index<=1">
        <!-- <div
         v-if="steelNo == item.no"
          class="steelRoller steelGif"
          :class="index == 0 ? 'steelLeftStyle' : 'steelRightStyle'"
        > -->
        <div
          :class="[
            'steelRoller',
            index == 1 ? 'steelLeftStyle' : 'steelRightStyle',
            item.typeName == '双钢轮' ? 'steelRollerDouble' : ''
          ]"
        >
        <div class="wifi" v-if="pavingStatus != 2"></div>
        <div :class="index == 1 ?' detail':'detailRight'" v-if="pavingStatus != 2 && steelNo == item.no">
            <div class="detailCon">
              <div class='poi'>{{item.typeName}}</div>
            <div class='poi'>编号:{{item.no}}</div>
            <div class='poi' v-if="item.temp!=null">温度:{{item.temp}}°C</div>
            <div class='poi'>速度:{{item.speed}}km/h</div>
            </div>
          </div>
        </div>
      </div>
        <div v-if="index>1">
          <div
            :class="[
              'steelRoller',
              index == 3 ? 'steelLeftStyle2' : 'steelRightStyle2',
              item.typeName == '双钢轮' ? 'steelRollerDouble' : ''
            ]"
          >
        <div class="wifi" v-if="pavingStatus != 2"></div>
        </div>
        </div>
      </div>
       <!-- @click="rubberDetailShow(item)" -->
      <div
        v-for="(item, index) in rubberRollerList"
        :key="index+'r'"
        :item-id="item.id"
       @click="rubberDetailShow(item)"
      >
      <div v-if="index <= 1">
        <div
          class="rubberRoller"
          :class="index == 1 ? 'rubberLeftStyle' : 'rubberRightStyle'"
        >
        <div class="wifi" v-if="pavingStatus != 2"></div>
        <div :class="index == 1 ?'detail':'detailRight'" v-if="pavingStatus != 2 && rubberNo == item.no">
            <div class="detailCon">
              <div>{{item.typeName}}</div>
            <div>编号:{{item.no}}</div>
            <div  v-if="item.temp!=null">温度:{{item.temp}}°C</div>
            <div>速度:{{item.speed}}km/h</div>
            </div>
          </div>
        </div>
      </div>
        <div v-if="index > 1">
          <div
            class="rubberRoller"
            :class="index == 3 ? 'rubberLeftStyle2' : 'rubberRightStyle2'"
          >
          <div class="wifi" v-if="pavingStatus != 2"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="frontCourt-em">
      <div class="tempBoard">
        <el-carousel
          indicator-position="none"
          height="100%"
          direction="vertical"
        >
          <el-carousel-item>
           {{this.board.windSpeed}}Km/h
          </el-carousel-item>
          <el-carousel-item>
          {{this.board.temp}}°C
          </el-carousel-item>
         <el-carousel-item>
          {{this.board.humidity}}%
          </el-carousel-item>
      </el-carousel>
      </div>
    </div> -->
  </div>
</template>
<script>
import { getFrontWork,getTempWind,getInitScreenData,getLastPaveTimeByWorkArea,getTransportTodaySummary } from "@/api/api";
import { mapState } from "vuex";
export default {
  props: {
    type:''
  },
  data() {
    return {
      firstInit:true,
      isOpenFront: false,
      stakeNo: {
        first: "",
        second: "",
        third: "",
        fourth: "",
        fifth: "",
        sixth: ""
      },
      paveNo:"",
      steelNo:"",
      rubberNo:"",
      pavePlusList:[],
      steelRollerList:[],
      rubberRollerList:[],
      dischargePlates: [],
      pavingStatus: null,
      // pavePlusList: [{
      //   no:1,
      //   temp:13,
      //   speed:12
      // },{
      //   no:1,
      //   temp:13,
      //   speed:12
      // }],
      // steelRollerList: [{
      //   no:1,
      //   temp:13,
      //   speed:12,
      //    typeName:'qq'
      // },
      // {
      //   no:2,
      //   temp:13,
      //   speed:12,
      //    typeName:'qq'
      // }],
      // rubberRollerList: [{
      //   no:1,
      //   temp:13,
      //   speed:12,
      //    typeName:'qq'
      // },{
      //   no:2,
      //   temp:13,
      //   speed:12,
      //    typeName:'qq'
      // }],
      board:{
        windSpeed:"",
        temp:"",
        humidity:""
      }
    };
  },
  created() {
    this.dataRefreh();
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    transmit() {
      // this.$emit('onlyOne',2)
    },
    // 定时刷新数据函数
    dataRefreh() {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return;
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        this.getTW();
        this.getFrontWorkInfo()
        this.getDischargePlates()
      }, 30000);
    },
    // 停止定时器
    clear() {
      clearInterval(this.intervalId); //清除计时器
      this.intervalId = null; //设置为null
    },
    // 获取当前时间
    NumberFix(val) {
      // const dt = new Date();
      const y = val.getFullYear();
      const m = (val.getMonth() + 1).toString().padStart(2, "0");
      const d = val.getDate().toString().padStart(2, "0");
      const h = val.getHours().toString().padStart(2, "0");
      const mi = val.getMinutes().toString().padStart(2, "0");
      const s = val.getSeconds().toString().padStart(2, "0");
      return `${y}-${m}-${d} ${h}:${mi}:${s}`;
    },
    // 桩号转换字符
		pileNo2Str(value) {
		    var kkkk = Math.floor(value / 1000);
		    var kkk = Math.floor((value % 1000) / 100);
		    var kk = Math.floor((value % 100) / 10);
		    // var k = parseFloat(new Number(value % 10).toFixed(2));
		    var k = Math.floor(value % 10);
		    return 'K' + kkkk + '+' + kkk + '' + kk + '' + k
    },
    // 获取温度风速
    async getTW() {
      // 旧环境监测
      // let req = {
      //   sectionId: this.sectionId,
      //   workAreaId: this.workAreaId
      // }
      //  const twDataLQ = await getTempWind(req);
      // this.board.windSpeed = twDataLQ.data[0]
      // this.board.temp = twDataLQ.data[1]
      // this.board.humidity = twDataLQ.data[2]
      // 新环境监测
      let req = {
        engineeringConfigId:this.sectionId
        // engineeringConfigId: 1,
      };
      const ertData = await getInitScreenData(req);
      if (ertData.status == 200) {
        // this.board.windSpeed = ertData.data.resultData?ertData.data.resultData.windSpeed.toFixed(2):""
        // this.board.temp = ertData.data.resultData?ertData.data.resultData.envTemperature.toFixed(2):""
        // this.board.humidity = ertData.data.resultData?ertData.data.resultData.envHumidity.toFixed(2):""
      }
    },
    // 获取卸料中车牌
    async getDischargePlates() {
      if (!this.mixplantId) return;
      let req = {
        materialType: this.type || 'lq',
        mixplantId: this.mixplantId,
        sectionId: this.seIds,
      };
      try {
        const res = await getTransportTodaySummary(req);
        const carNos = (res && res.data && res.data.unloading && res.data.unloading.carNos) || [];
        this.dischargePlates = carNos;
      } catch (e) {
        console.error('获取卸料中车牌失败', e);
      }
    },
    // 获取前场数据
    async getFrontWorkInfo() {
      const paveRes = await getLastPaveTimeByWorkArea({
        workAreaId: this.sectionId
      })
      const paveBody = paveRes && paveRes.data
      const pavePayload = (paveBody && paveBody.resultData != null)
        ? paveBody.resultData
        : paveBody
      let paveTime = ''
      this.pavingStatus = null
      if (typeof pavePayload === 'string' || typeof pavePayload === 'number') {
        paveTime = pavePayload
      } else if (pavePayload && typeof pavePayload === 'object') {
        paveTime = pavePayload.paveTime || ''
        this.pavingStatus = pavePayload.pavingStatus
      }
      if (!paveTime) {
        this.pavePlusList = []
        this.steelRollerList = []
        this.rubberRollerList = []
        return
      }
      const dateAfter = new Date(String(paveTime).replace(/-/g, '/'))
      if (isNaN(dateAfter.getTime())) {
        this.pavePlusList = []
        this.steelRollerList = []
        this.rubberRollerList = []
        return
      }
      const dateBefore = new Date(dateAfter.getTime() - 1 * 60 * 60 * 1000)
      let endDateTime = this.NumberFix(dateAfter)
      let startDateTime = this.NumberFix(dateBefore)
      let req = {
        endDateTime: endDateTime,
        materialType: this.type,
        sectionId: this.seIds,
        startDateTime: startDateTime,
        // startDateTime:'2020-12-16 6:04:49',
        workAreaId: this.sectionId
      }
      const fwiDataLQ = await getFrontWork(this.type, req);
      console.log(fwiDataLQ)
      // 过滤在线摊铺机
      this.pavePlusList =  fwiDataLQ.data.pavers?fwiDataLQ.data.pavers.filter(
            (item) => item.online == true
          ):[];
      // this.pavePlusList =[{
      //   no:1,
      //   temp:13,
      //   speed:12
      // },{
      //   no:1,
      //   temp:13,
      //   speed:12
      // }]
      if(this.pavePlusList.length<=1) {
        this.$emit('onlyOne',1)
      }else {
        this.$emit('onlyOne',2)
      }
       console.log(this.pavePlusList)
      // console.log(this.paveNo)
      // 获取首辆摊铺机桩号
      let pavePileNo = ''
      if(this.pavePlusList.length != 0) {
        pavePileNo =this.pileNo2Str(this.pavePlusList[0].pileNo)
      }
      // 过滤在线碾压机
      let onlineM = fwiDataLQ.data.rollers?fwiDataLQ.data.rollers.filter(
            (item) => item.online == true
          ):[];
          console.log(onlineM)
          console.log(onlineM)
      // 获取首辆碾压机桩号
      let rollerPileNo = ''
      if(onlineM.length != 0) {
        rollerPileNo =this.pileNo2Str(onlineM[0].pileNo)
      }
      // 摊铺机与碾压机桩号选其一
      this.stakeNo = {
        first:'',
        second:'',
        third:'',
        fourth:'',
        fifth:'',
        sixth:'',
      }
      console.log(rollerPileNo)
      if(onlineM.length != 0||this.pavePlusList.length != 0) {
      // this.stakeNo = {
      //   first: (pavePileNo?pavePileNo:rollerPileNo).split('+')[0]+'+'+((pavePileNo?pavePileNo:rollerPileNo).split('+')[1]-0-2),
      //   second: (pavePileNo?pavePileNo:rollerPileNo).split('+')[0]+'+'+((pavePileNo?pavePileNo:rollerPileNo).split('+')[1]-0-1),
      //   third: pavePileNo?pavePileNo:rollerPileNo,
      //   fourth: (pavePileNo?pavePileNo:rollerPileNo).split('+')[0]+'+'+((pavePileNo?pavePileNo:rollerPileNo).split('+')[1]-0+1),
      //   fifth: (pavePileNo?pavePileNo:rollerPileNo).split('+')[0]+'+'+((pavePileNo?pavePileNo:rollerPileNo).split('+')[1]-0+2),
      //   sixth: (pavePileNo?pavePileNo:rollerPileNo).split('+')[0]+'+'+((pavePileNo?pavePileNo:rollerPileNo).split('+')[1]-0+3)
      // }
      this.stakeNo = {
        first: pavePileNo?this.pileNo2Str(this.pavePlusList[0].pileNo-2):this.pileNo2Str(onlineM[0].pileNo-2),
        second: pavePileNo?this.pileNo2Str(this.pavePlusList[0].pileNo-1):this.pileNo2Str(onlineM[0].pileNo-1),
        third: pavePileNo?pavePileNo:rollerPileNo,
        fourth: pavePileNo?this.pileNo2Str(this.pavePlusList[0].pileNo+1):this.pileNo2Str(onlineM[0].pileNo+1),
        fifth: pavePileNo?this.pileNo2Str(this.pavePlusList[0].pileNo+2):this.pileNo2Str(onlineM[0].pileNo+2),
        sixth: pavePileNo?this.pileNo2Str(this.pavePlusList[0].pileNo+3):this.pileNo2Str(onlineM[0].pileNo+3)
      }
      }

      // 过滤钢轮
    this.steelRollerList = onlineM?onlineM.filter(
            (item) => item.typeName.indexOf('钢') >= 0
          ):[];
      // 过滤胶轮
        this.rubberRollerList = onlineM?onlineM.filter(
            (item) => item.typeName.indexOf('胶') >= 0
          ):[];
    if(this.firstInit == true) {
       this.paveNo = this.pavePlusList[0].no
     this.steelNo = this.steelRollerList[0].no
     this.rubberNo = this.rubberRollerList[0].no
     this.firstInit = false
    }
    if(this.pavePlusList.length==0&&this.steelRollerList.length==0&&this.rubberRollerList.length == 0) {
      this.firstInit = true
    }
     console.log(this.pavePlusList)
     console.log(this.steelRollerList)
     console.log(this.rubberRollerList)
    },
    // 查看摊铺机详情
    paveDetailShow(val) {
      console.log(val.no)
      console.log(this.paveNo)
      this.steelNo = "";
      this.rubberNo = "";
      if(val.no ==  this.paveNo) {
        this.paveNo = ""
      }else {
        this.paveNo = val.no
      }
    },
    // 查看钢轮详情
    steelDetailShow(val) {
      this.paveNo = "";
      this.rubberNo = "";
      if(val.no ==  this.steelNo) {
        this.steelNo = ""
      }else {
        this.steelNo = val.no
      }
    },
    // 查看胶轮详情
    rubberDetailShow(val) {
      this.paveNo = "";
      this.steelNo = "";
       if(val.no ==  this.rubberNo) {
        this.rubberNo = ""
      }else {
        this.rubberNo = val.no
      }
    },
    async openFront() {
      let req = {
        workareaId : this.sectionId
      }
      //  const data = await getChannels(req);
      // console.log(data)
      // if(data.status != 200) {
      //   return
      // }
      this.isOpenFront = !this.isOpenFront
      this.$store.commit("updataFronCourOpen", this.isOpenFront);
    }
  },
   computed: mapState(["engineerId", "sectionId", "workAreaId", "mixplantId", "seIds"]),
  watch: {
    isType(curVal, oldVal) {

    },
    sectionId(curVal, oldVal) {
      if (!curVal || curVal === oldVal) return
      this.getFrontWorkInfo()
      this.getTW()
      this.getDischargePlates()
    },
    mixplantId(curVal, oldVal) {
      if (!curVal || curVal === oldVal) return
      this.getDischargePlates()
    },
    workAreaId(curVal, oldVal) {}
  }
};
</script>

<style lang="less" scoped>
.frontconrtM {
  position: absolute;
  width: 100%;
  height: 100%;
  .stakeNo {
    position: absolute;
    left: 20px;
    bottom: 20px;
    color: #44f8ff;
    width: 1350px;
    font-size: 16px;
    font-weight: 700;
    text-shadow: 0.1em 0.1em 0.05em #000;
    transform: rotate(-56deg);
    // transform: rotate(-59deg);
    transform-origin: bottom left;
    // animation:stakeNo 5s linear infinite;
    div {
      margin-right: 140px;
    }
    .first {
      position: relative;
      transform: rotate(10deg);
      display: inline-block;
    }
    .second {
      position: relative;
      top: 26px;
      transform: rotate(4deg);
      display: inline-block;
    }
    .third {
      position: relative;
      top: 36px;
      left: 40px;
      display: inline-block;
    }
    .fourth {
      position: relative;
      top: 30px;
      left: 30px;
      transform: rotate(-2deg);
      display: inline-block;
    }
    .fifth {
      position: relative;
      top: 24px;
      left: 40px;
      display: inline-block;
    }
    .sixth {
      position: relative;
      top: 28px;
      left: 36px;
      transform: rotate(2deg);
      display: inline-block;
    }
  }
    @keyframes stakeNo {
    0% {
      transform:rotate(-56deg) translateX(0)
    }
    100% {
      transform:rotate(-56deg) translateX(50px)
    }
  }
  .frontCourt-em {
    position: absolute;
    bottom: 10px;
    right: 280px;
    font-size: 10px;
    font-family: Microsoft YaHei;
    color: #fd3b4f;
    text-align: center;
    width: 84px;
    height: 138px;
    background-image: url(../assets/img/frontCourt-em@2x.png);
    background-size: 100% 100%;
    .tempBoard {
      position: absolute;
      top:50px;
      height: 26px;
      width: 100%;
      overflow: hidden;
      .el-carousel {
      height: 100%;
    }
    }

  }
  .Mechanics {
    position: absolute;
    top: 0;
    right: 0;
    // background-color: rgba(0, 0, 0, 0.3);
    width: 500px;
    height: 700px;
    // 摊铺机
    .pavePlus {
      position: absolute;
      width: 120px;
      height: 200px;
      .wifi {
        position: absolute;
        width: 26px;
        height: 15px;
        top: -20px;
        left:34px;
        background-image: url(../assets/gif/wifi.gif);
        background-size: 100% 100%;
      }
      .noWifi {
        top: -20px;
        left:95px;
      }
      .detail {
        position: absolute;
        z-index: 5;
        width: 280px;
        height: 88px;
        right:-250px;
        background-image: url(../assets/gif/line3.gif);
        background-size: 100% 60%;
        background-repeat: no-repeat;
        background-position: bottom center;
        // background-color: rgba(0,0,0,0.3);
        font-size: 14px;
        font-weight: bold;
        color: #44F8FF;
        .detailCon {
          float:right;
          margin-right:30px;
        }
      }
      .detailRight {
        position: absolute;
        z-index: 5;
        width: 200px;
        height: 88px;
        right:-200px;
        background-image: url(../assets/gif/line2.gif);
        background-size: 100% 60%;
        background-repeat: no-repeat;
        background-position: bottom center;
        // background-color: rgba(0,0,0,0.3);
        font-size: 12px;
        font-weight: bold;
        color: #44F8FF;
        .detailCon {
          float:right;
          margin-right:30px;
        }
      }
      .cameraFront {
         position: absolute;
        width: 17px;
        height: 21px;
        top: -10px;
        right:34px;
        background-image: url(../assets/img/icon-camera@2x.png);
        background-size: 100% 100%;
      }
      .middleV {
        z-index: 998;
        right:-30px !important;
      }
      .twoV {
        right:34px !important;
      }
      .transportCar {
        position: absolute;
        width: 130px;
        height: 96px;
        // background-image: url(../assets/img/icon-paver@2x.png);
        background-size: 100% 100%;
      }
      .paveMachine {
        position: absolute;
        bottom: 50px;
        left: -20px;
        width: 90px;
        height: 90px;
        background-image: url(../assets/img/icon-w_truck-paver@2x.png);
        background-size: 100% 100%;
      }
      .dischargePlate {
        position: absolute;
        z-index: 8;
        bottom: 90px;
        left: -16px;
        width: 83px;
        height: 40px;
        line-height: 30px;
        text-align: center;
        font-size: 11px;
        font-weight: 700;
        color: #000;
        background-image: url(../assets/img/cph.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 4px;
        box-sizing: border-box;
        pointer-events: none;
      }
      .middlePlate {
        left: 20px !important;
      }
    }
    .middle {
      bottom: -11%;
      left: 1%;
      // transform:rotate(-2deg);
    }
    .middleT {
      left: 30px !important;
    }
    .leftStyle {
      bottom: 4%;
      left: 14%;
    }
    .rightStyle {
      bottom: -10%;
      left: 28%;
    }
    .poi {
      position: relative;
      z-index: 10;
    }
    // 钢轮
    .steelRoller {
      position: absolute;
      width: 90px;
      height: 90px;
      z-index: 7;
      background-image: url(../assets/img/dgl.png);
      background-size: 100% 100%;
      .wifi {
        position: absolute;
        width: 26px;
        height: 15px;
        top: -20px;
        left:28px;
        background-image: url(../assets/gif/wifi.gif);
        background-size: 100% 100%;
      }
      .detail {
        position: absolute;
        z-index: 5;
        width: 250px;
        height: 88px;
        right:-250px;
        background-image: url(../assets/gif/line1.gif);
        background-size: 100% 60%;
        background-repeat: no-repeat;
        background-position: bottom center;
        // background-color: rgba(0,0,0,0.3);
        font-size: 14px;
        font-weight: bold;
        color: #44F8FF;
        .detailCon {
          float:right;
          margin-right:30px;
        }
      }
      .detailRight {
        position: absolute;
        z-index: 5;
        width: 150px;
        height: 88px;
        right:-150px;
        background-image: url(../assets/gif/line2.gif);
        background-size: 100% 60%;
        background-repeat: no-repeat;
        background-position: bottom center;
        // background-color: rgba(0,0,0,0.3);
        font-size: 12px;
        font-weight: bold;
        color: #44F8FF;
        .detailCon {
          float:right;
          margin-right:30px;
        }
      }
    }
    .steelGif {
      background-image: url(../assets/gif/steelGif.gif);
    }
    .steelRollerDouble {
      background-image: url(../assets/img/sgl.png);
    }
    .steelLeftStyle {
      bottom: 36%;
      left: 30%;
    }
    .steelRightStyle {
      bottom: 21%;
      left: 42%;
    }
    .steelLeftStyle2 {
       top: 20%;
      right: 24%;
    }
    .steelRightStyle2 {
      top: 34%;
      right: 14%;
    }
    // 胶轮
    .rubberRoller {
      position: absolute;
      width: 90px;
      height: 90px;
      z-index: 7;
      background-image: url(../assets/img/icon-g_lroller@2x.png);
      background-size: 100% 100%;
      .wifi {
        position: absolute;
        width: 26px;
        height: 15px;
        top: -20px;
        left:28px;
        background-image: url(../assets/gif/wifi.gif);
        background-size: 100% 100%;
      }
      .detail {
        position: absolute;
        z-index: 5;
        width: 180px;
        height: 88px;
        right:-180px;
        background-image: url(../assets/gif/line1.gif);
        background-size: 100% 60%;
        background-repeat: no-repeat;
        background-position: bottom center;
        // background-color: rgba(0,0,0,0.3);
        font-size: 14px;
        font-weight: bold;
        color: #44F8FF;
        .detailCon {
          float:right;
          margin-right:30px;
        }
      }
      .detailRight {
        position: absolute;
        z-index: 5;
        width: 140px;
        height: 88px;
        right:-135px;
        background-image: url(../assets/gif/line2.gif);
        background-size: 100% 60%;
        background-repeat: no-repeat;
        background-position: bottom center;
        // background-color: rgba(0,0,0,0.3);
        font-size: 12px;
        font-weight: bold;
        color: #44F8FF;
        .detailCon {
          float:right;
          margin-right:30px;
        }
      }
    }
    .rubberLeftStyle {
      bottom: 52%;
      left: 44%;
    }
    .rubberRightStyle {
      bottom: 37%;
      left: 54%;
    }
    .rubberLeftStyle2 {
      top: 4%;
      right: 8%;
    }
    .rubberRightStyle2 {
      top: 19%;
      right: 1%;
    }
  }
}
.oneS {
  width: 260px !important;
  background-image: url(../assets/img/icon-paver33.png);
}
.twoS {
  background-image: url(../assets/img/icon-paver@2x.png);
}
.qj {
  position: absolute;
          right: -250px;
          height: 980px;
          width: 250px;
          background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/subassembly/frontconrt.vue